import { Action } from '@ngrx/store';
import {
  TListingFetchReason,
  TNeedleRequestStatus,
  TRAISE_NEEDLE_REQUEST,
  TREQUEST_BULK_UPDATE_SPAREPART_REQUEST_STATUS,
  TREQUEST_NEEDLE_APPROVE,
  TREQUEST_NEEDLE_DELETE,
  TREQUEST_NEEDLE_LIST,
  TREQUEST_NEEDLE_UPDATE,
  TREQUEST_SPAREPART_REQUEST_LIST,
  TRESPONSE_GET_NEEDLE_REQUESTS,
  TRESPONSE_LOCAL_NEEDLE_STORE_REQUEST,
  TRESPONSE_NEEDLE_LIST,
  TRESPONSE_UPDATE_NEEDLE_FIELD_DROPDOWN,
} from '@monorepo/types';
import { TUserPaginationOption } from '@monorepo/ui';
import { TNeedleManagementInfoActionType } from './needle-management.models';

export class GetNeedleListInfo implements Action {
  readonly type = TNeedleManagementInfoActionType.GetNeedleList;
  constructor(
    public payload: Omit<TREQUEST_NEEDLE_LIST, 'page' | 'itemsPerPage'>,
    public fetchReason: TListingFetchReason,
  ) {}
}
export class GetNeedleListInfoSuccess implements Action {
  readonly type = TNeedleManagementInfoActionType.GetNeedleListSuccess;
  constructor(public needleListRes: TRESPONSE_NEEDLE_LIST, public fetchReason: TListingFetchReason) {}
}

export class GetNeedleListInfoFailure implements Action {
  readonly type = TNeedleManagementInfoActionType.GetNeedleListFailure;
}

export class SetNeedleListPagination implements Action {
  readonly type = TNeedleManagementInfoActionType.SetNeedleListPagination;
  constructor(public pagination: TUserPaginationOption) {}
}

export class GetNeedleListDropdown implements Action {
  readonly type = TNeedleManagementInfoActionType.GetNeedleListDropdown;
}

export class GetNeedleListDropdownSuccess implements Action {
  readonly type = TNeedleManagementInfoActionType.GetNeedleListDropdownSuccess;
  constructor(public res: TRESPONSE_UPDATE_NEEDLE_FIELD_DROPDOWN) {}
}

export class GetNeedleListDropdownFailure implements Action {
  readonly type = TNeedleManagementInfoActionType.GetNeedleListDropdownFailure;
}

export class UpdateNeedle implements Action {
  readonly type = TNeedleManagementInfoActionType.UpdateNeedle;
  constructor(public updatedNeedle: TREQUEST_NEEDLE_UPDATE) {}
}

export class UpdateNeedleSuccess implements Action {
  readonly type = TNeedleManagementInfoActionType.UpdateNeedleSuccess;
}

export class UpdateNeedleFailure implements Action {
  readonly type = TNeedleManagementInfoActionType.UpdateNeedleFailure;
}

export class DeleteNeedle implements Action {
  readonly type = TNeedleManagementInfoActionType.DeleteNeedle;
  constructor(public needleIds: TREQUEST_NEEDLE_DELETE['needleIds']) {}
}

export class DeleteNeedleSuccess implements Action {
  readonly type = TNeedleManagementInfoActionType.DeleteNeedleSuccess;
}

export class DeleteNeedleFailure implements Action {
  readonly type = TNeedleManagementInfoActionType.DeleteNeedleFailure;
}

export class RaiseNeedleRequest implements Action {
  readonly type = TNeedleManagementInfoActionType.RaiseNeedleRequest;
  constructor(public payload: TRAISE_NEEDLE_REQUEST) {}
}

export class RaiseNeedleRequestSuccess implements Action {
  readonly type = TNeedleManagementInfoActionType.RaiseNeedleRequestSuccess;
}

export class RaiseNeedleRequestFailure implements Action {
  readonly type = TNeedleManagementInfoActionType.RaiseNeedleRequestFailure;
}

export class SetNeedleRequestPagination implements Action {
  readonly type = TNeedleManagementInfoActionType.SetNeedleRequestPagination;
  constructor(public pagination: TUserPaginationOption) {}
}

export class GetNeedleRequestList implements Action {
  readonly type = TNeedleManagementInfoActionType.GetNeedleRequestList;
  constructor(
    public payload: Omit<TREQUEST_SPAREPART_REQUEST_LIST, 'page' | 'itemsPerPage'>,
    public fetchReason: TListingFetchReason,
  ) {}
}
export class GetNeedleRequestListSuccess implements Action {
  readonly type = TNeedleManagementInfoActionType.GetNeedleRequestListSuccess;
  constructor(public res: TRESPONSE_GET_NEEDLE_REQUESTS, public fetchReason: TListingFetchReason) {}
}

export class GetNeedleRequestListFailure implements Action {
  readonly type = TNeedleManagementInfoActionType.GetNeedleRequestListFailure;
}

export class BulkUpdateNeedleRequest implements Action {
  readonly type = TNeedleManagementInfoActionType.BulkUpdateNeedleRequest;
  constructor(public payload: TREQUEST_BULK_UPDATE_SPAREPART_REQUEST_STATUS, public status: TNeedleRequestStatus) {}
}

export class BulkUpdateNeedleRequestSuccess implements Action {
  readonly type = TNeedleManagementInfoActionType.BulkUpdateNeedleRequestSuccess;
}

export class BulkUpdateNeedleRequestFailure implements Action {
  readonly type = TNeedleManagementInfoActionType.BulkUpdateNeedleRequestFailure;
}

export class ApproveNeedleRequest implements Action {
  readonly type = TNeedleManagementInfoActionType.ApproveNeedleRequest;
  constructor(public payload: TREQUEST_NEEDLE_APPROVE, public status: TNeedleRequestStatus) {}
}

export class ApproveNeedleRequestSuccess implements Action {
  readonly type = TNeedleManagementInfoActionType.ApproveNeedleRequestSuccess;
}

export class ApproveNeedleRequestFailure implements Action {
  readonly type = TNeedleManagementInfoActionType.ApproveNeedleRequestFailure;
}

export class SetLocalNeedleRequestPagination implements Action {
  readonly type = TNeedleManagementInfoActionType.SetLocalNeedleRequestPagination;
  constructor(public pagination: TUserPaginationOption) {}
}

export class GetLocalStoreRequests implements Action {
  readonly type = TNeedleManagementInfoActionType.GetLocalStoreRequests;
  constructor(
    public payload: Omit<TREQUEST_SPAREPART_REQUEST_LIST, 'page' | 'itemsPerPage'>,
    public fetchReason: TListingFetchReason,
  ) {}
}

export class GetLocalStoreRequestsSuccess implements Action {
  readonly type = TNeedleManagementInfoActionType.GetLocalStoreRequestsSuccess;
  constructor(public res: TRESPONSE_LOCAL_NEEDLE_STORE_REQUEST, public fetchReason: TListingFetchReason) {}
}

export class GetLocalStoreRequestsFailure implements Action {
  readonly type = TNeedleManagementInfoActionType.GetLocalStoreRequestsFailure;
}

export type TNeedleManagementActions =
  | SetNeedleListPagination
  | GetNeedleListInfo
  | GetNeedleListInfoSuccess
  | GetNeedleListInfoFailure
  | GetNeedleListDropdown
  | GetNeedleListDropdownSuccess
  | GetNeedleListDropdownFailure
  | UpdateNeedle
  | UpdateNeedleSuccess
  | UpdateNeedleFailure
  | DeleteNeedle
  | DeleteNeedleSuccess
  | DeleteNeedleFailure
  | RaiseNeedleRequest
  | RaiseNeedleRequestSuccess
  | RaiseNeedleRequestFailure
  | SetNeedleRequestPagination
  | GetNeedleRequestList
  | GetNeedleRequestListSuccess
  | GetNeedleRequestListFailure
  | BulkUpdateNeedleRequest
  | BulkUpdateNeedleRequestSuccess
  | BulkUpdateNeedleRequestFailure
  | ApproveNeedleRequest
  | ApproveNeedleRequestSuccess
  | ApproveNeedleRequestFailure
  | SetLocalNeedleRequestPagination
  | GetLocalStoreRequests
  | GetLocalStoreRequestsSuccess
  | GetLocalStoreRequestsFailure;
